import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import keys from 'constants/keys'

interface UseLinkedKpi {
  ref_id: string | undefined
}

export const useLinkedKpi = ({ ref_id }: UseLinkedKpi) => {
  const navigate = useNavigate()
  const kpis = useSelector((state: RootState) => state.ranking.kpisList)

  const isPostLinkedToKpi = ref_id?.includes('kpis-')

  const kpiId = useMemo(() => {
    if (isPostLinkedToKpi && ref_id) {
      return ref_id.split('kpis-').pop()
    }
    return null
  }, [isPostLinkedToKpi, ref_id])

  const currentLinkedKpi = useMemo(() => {
    if (kpiId) {
      return kpis.find((kpi) => kpi.id === kpiId)
    }
    return null
  }, [kpiId, kpis])

  const handleNavigateToKpi = useCallback(() => {
    if (kpiId) {
      return navigate(keys.ROUTE_NAMES.RANKING(kpiId))
    }
  }, [kpiId, navigate])

  return {
    isPostLinkedToKpi,
    handleNavigateToKpi,
    currentLinkedKpi,
  }
}
